export default function initBanner() {
  const now = new Date().getTime();
  /**
   * PROD DATES
   * {
      start: new Date(Date.parse('2024-11-25T00:00:00.000Z')).getTime(), - need hours
      end: new Date(Date.parse('2024-12-09T07:59:00.000Z')).getTime(),
    };
  */
  const dateRange = {
    start: new Date(Date.parse('2024-11-17T09:00:00.000Z')).getTime(),
    end: new Date(Date.parse('2024-12-09T07:59:00.000Z')).getTime(),
  };
  const show = now >= dateRange.start && now < dateRange.end
    && !localStorage.getItem('hideBlackFriday');

  const $close = $('.black-friday-banner .close');
  const hide = function hide() {
    localStorage.setItem('hideBlackFriday', true);
    $('body').removeClass('black-friday-event');
  };

  if (show) {
    $('body').addClass('black-friday-event');
  }

  $close.on('click', hide);
}
